(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kf-club"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('.kf-club');
    if (!raiz) return;
    var gate = document.getElementById('kf-club-gate');
    var conteudo = document.getElementById('kf-club-conteudo');
    var form = document.getElementById('kf-club-form');
    var input = document.getElementById('kf-club-input');
    var erro = document.getElementById('kf-club-erro');
    var senha = (raiz.getAttribute('data-senha') || '').toUpperCase();

    function abrir() {
      gate.hidden = true;
      conteudo.hidden = false;
    }

    if (sessionStorage.getItem('kfclub_ok') === '1') abrir();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (input.value.trim().toUpperCase() === senha) {
        sessionStorage.setItem('kfclub_ok', '1');
        erro.hidden = true;
        abrir();
      } else {
        erro.hidden = false;
        input.value = '';
        input.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
